import { Analytics } from "@segment/analytics-node";
import { WriteKeyMap } from "./utils";
import { AnalyticsInstance, EventProperties } from "./Analytics";
import packageInfo from "package.json";
import { ContextManager, ContextInstance } from "~/modules/contextManager/ContextManager";
import { ClientOptionsStore } from "~/modules/client/ClientOptions/ClientOptionsStore";
import { getEnvironmentConfig } from "~/modules/config";
import { getLogger, LoggerName, Logger } from "~/modules/logger";
import { getOrigin } from "~/utils/getOrigin";
import { parseRegionForAnalytics, RegionType } from "~/utils/regionUtil";






declare namespace window {
    
    let __TWILIO_FLEX_SDK_E2E__: { eagerTelemetryFlush?: boolean } | undefined;
}




export class AnalyticsImpl implements AnalyticsInstance {
    private analytics: Analytics | undefined;

    private readonly commonProperties: EventProperties = {};

    private disabled: boolean = false;

    private readonly clientOptions: ClientOptionsStore;

    private readonly logger: Logger;

    private readonly env: RegionType;

    constructor(ctx: ContextManager) {
        this.clientOptions = ctx.retrieveInstanceOf(ContextInstance.ClientOptionsStore, ClientOptionsStore);
        this.logger = getLogger(ctx)(LoggerName.Analytics);
        const environmentConfig = getEnvironmentConfig();
        const { region } = environmentConfig ?? {};
        const origin = getOrigin();
        const configRegion = region ?? this.clientOptions.region ?? "us1";
        this.env = parseRegionForAnalytics(configRegion);
        const flexUiVersion = origin === "flexui" && this.clientOptions.appVersion;
        this.commonProperties = {
            product: "Flex",
            source: "flexsdk",
            realm: configRegion,
            flexSdkVersion: packageInfo.version,
            origin,
            ...(flexUiVersion && { flexUiVersion })
        };
    }

    









    public init(telemetryDisabled: boolean, writeKeyMap?: WriteKeyMap): void {
        try {
            if (telemetryDisabled) {
                this.disabled = true;
                return;
            }

            const writeKey = writeKeyMap?.analytics?.[this.env] ?? writeKeyMap?.analytics?.prod ?? undefined;

            if (!writeKey) {
                this.logger.warn("FlexSDK Telemetry Key not found. The FlexSDK Telemetry will be disabled.");
                this.disabled = true;
                return;
            }

            
            
            const hostRegion = this.env === "prod" ? "us1" : `stage-us1`;

            
            
            
            const eagerFlush =
                typeof window !== "undefined" && window.__TWILIO_FLEX_SDK_E2E__?.eagerTelemetryFlush === true;

            this.analytics = new Analytics({
                writeKey,
                host: `https://api.flexsdkanalytics.${hostRegion}.twilio.com/v1`,
                ...(eagerFlush ? { flushAt: 1, flushInterval: 500 } : {})
            });
        } catch (e) {
            this.logger.warn("Failed to initialise FlexSDK Analytics", e);
            this.disabled = true;
        }
    }

    public track = (eventName: string, eventProperties?: EventProperties): void => {
        if (this.disabled) {
            return;
        }

        if (!this.analytics) {
            this.logger.warn("Analytics is not initialized");
            return;
        }

        try {
            this.analytics.track({
                
                userId: eventProperties?.userId,
                
                anonymousId: eventProperties?.anonymousId,
                event: eventName,
                properties: { ...this.commonProperties, ...eventProperties }
            });
        } catch (err) {
            this.logger.warn(err);
        }
    };
}
